import React from 'react';
import { GMStatuses } from 'Components/utils/customer-account/ca.constants';
import { t } from 'Src/i18n';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
import { GreatMemberStatus } from 'Components/widgets/great-member-status/GreatMemberStatus';
type Props = {
  loyaltyProgram: Array<LoyaltyProgram>;
  profile: {
    isPlatinumForLife?: boolean;
    points: number;
    status: GreatMembersStatus;
  };
};
export const GreatMembersIntroduction = ({ loyaltyProgram, profile }: Props) => {
  const userStatus = profile?.status || '';
  const hasStatus = Object.values(GMStatuses).includes(userStatus);

  if (!hasStatus) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-20 md:grid-cols-2">
      <div>
        <Title className={`mb-10 text-${userStatus}`} theme="title-brand-n2">
          {t(`customerAccount.greatMember.introduction.${userStatus}.title`)}
        </Title>
        <Text
          text={t(`customerAccount.greatMember.introduction.${userStatus}.text`)}
          theme="text-sans-n3"
        />
      </div>
      <GreatMemberStatus loyaltyProgram={loyaltyProgram} profile={profile} />
    </div>
  );
};
